import absa from './assets/images/banks_logo/Absa.svg'
import capitec from './assets/images/banks_logo/Capitec.svg'
import nedPay from './assets/images/banks_logo/NedbankPay.png'
import fnb from './assets/images/banks_logo/FNB.svg'
import investec from './assets/images/banks_logo/Investec.svg'
import nedbank from './assets/images/banks_logo/Nedbank.svg'
import standardBank from './assets/images/banks_logo/Standard Bank.svg'
import tymeBank from './assets/images/banks_logo/Tyme Bank.svg'
import bidvestBank from './assets/images/banks_logo/Bidvest Bank.svg'
import africanBank from './assets/images/banks_logo/African Bank.svg'

import absaForm from './assets/images/forms_logo/ABSA_Group_Limited_Logo.svg'
import capitecForm from './assets/images/forms_logo/Capitec-Logo.svg'
import fnbForm from './assets/images/forms_logo/FNB-Logo.svg'
import investecForm from './assets/images/forms_logo/Investec_Logo.svg'
import nedbankForm from './assets/images/forms_logo/Nedbank_Logo.svg'
import standardBankForm from './assets/images/forms_logo/Standard_Bank_Logo.svg'
import tymeBankForm from './assets/images/forms_logo/Tyme_Bank_Logo.svg'
import bidvestBankForm from './assets/images/forms_logo/Bidvest_Bank_Logo.svg'
import africanBankForm from './assets/images/forms_logo/African_Bank_Logo.svg'
import mockBank from './assets/images/logo.svg'

import AbsaBankForm from '@/forms/AbsaBankForm.vue'
import InvestecBankForm from '@/forms/InvestecBankForm'
import CapitecBankForm from '@/forms/CapitecBankForm'
import StandardBankForm from '@/forms/StandardBankForm.vue'
import NedBankForm from '@/forms/NedBankForm'
import FnbBankForm from '@/forms/FnbBankForm'
import TymeBankForm from '@/forms/TymeBankForm'
import BidvestBankForm from '@/forms/BidvestBankForm'
import AfricanBankForm from '@/forms/AfricanBankForm'
import CapitecPayBankForm from '@/forms/CapitecPayBankForm'
import NedbankPayBankForm from '@/forms/NedbankPayBankForm'
import AbsaPayBankForm from '@/forms/AbsaPayBankForm'
import MockBankForm from '@/forms/MockBankForm'

const acquirerCodes = Object.freeze({
  Absa: 'WTSMO44703',
  Capitec: 'ATGFI38291',
  CapitecPay: 'CVLVK60312',
  NedbankPay: 'XNWXQ78221',
  AbsaPay: 'LTAQI15904',
  FNB: 'CVUFO51443',
  Nedbank: 'EFHZR46394',
  StandardBank: 'DHJMA43223',
  Investec: 'LQAVS25843',
  Tyme: 'TQEOF65871',
  AfricanBank: 'NBEPY08293',
  BidvestBank: 'QNUIR98745',
  SidDemo: 'JENBU39797',
})

const bankNames = Object.freeze({
  ABSA: 'ABSA',
  CAPPAY: 'Capitec Pay',
  NEDPAY: 'Nedbank Direct',
  ABSAPAY: 'Absa Pay',
  CAPITEC: 'Capitec',
  FNB: 'FNB',
  SBSA: 'Standard Bank',
  NEDBANK: 'Nedbank',
  INVESTEC: 'Investec',
  TYME: 'Tyme Bank',
  BIDVEST: 'Bidvest Bank',
  AFRICAN: 'African Bank',
  SID: 'SID Demo',
})

const logMessages = Object.freeze({
  cancelOnBankSelect: 'Bank Select - User clicked Cancel',
  signalRConnected: 'Paysid connected to SignalR',
  joinedSignalRGroup(transactionId) {
    return `Paysid Joined SignalR group - ${transactionId}`
  },
  showTransaction(transactionStatus) {
    return `Showing Transaction  ${transactionStatus}`
  },
  showTransactionCreated: 'Showing transaction created',
  showCompleted: 'Show completed',
  showRetry: 'Show retry',
  cancelTransaction: 'Attempting to cancel transaction',
  cancelTransactionFailed: 'Failed to cancel transaction',
  showLogin: 'Showing Login Input',
  showPartialPassword: 'Showing Partial Password Input',
  showOtp: 'Showing OTP Input',
  showAccounts: 'Showing Account Selection',
  showConfirmCancel: 'Showing confirm cancel',
  showLoginAndCaptcha: 'Showing Login and Captcha input',
  enteredLogin: 'User entered Login details',
  enteredLoginAndCaptcha: 'User entered Login and Captcha details',
  enteredOtp: 'User entered OTP details',
  otpResend: 'User requested OTP resend',
  selectedAccount: 'User selected account',
  enteredPartialPassword: 'User entered Partial Password details',
  captchaMessage: 'Please re-enter your login details and complete the Captcha',
  duplicateTab:
    'User opened transaction in another tab - redirecting to error page.',
  enteredAtmPin: 'User entered ATM PIN',
  approvalTimerExpired: 'User approval timer expired',
})

const capitecPayInputConfig = Object.freeze({
  mobile: {
    key: 'CELLPHONE',
    label: 'Mobile Number',
    regex:
      /^(^[\\+27][ 0-9]{14})|(^[\\+27]( ?)[0-9]{11})|(^0[0-9]{9})|(^0[ 0-9]{11})$/,
  },
  account: {
    key: 'ACCOUNTNUMBER',
    label: 'Account Number',
    regex: /^[0-9]{8,}$/,
  },
  id: {
    key: 'IDNUMBER',
    label: 'ID Number',
    regex: /^.+$/,
  },
})

const absaPayInputConfig = Object.freeze({
  account: Object.freeze({
    key: 'ACCOUNT',
    label: 'Account Number',
    regex: /^\d{1,20}$/,
    isHighRiskKey: false,
    isHighRiskDefault: false,
  }),
  id: Object.freeze({
    key: 'SAID',
    label: 'ID Number',
    regex: /^(?:\d{2})(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])\d{7}$/,
    isHighRiskKey: true,
    isHighRiskDefault: true,
  }),
  passport: Object.freeze({
    key: 'PASSPORT',
    label: 'Passport Number',
    regex: /^\d{1,20}$/,
    isHighRiskKey: true,
    isHighRiskDefault: false,
  }),
})

const requestTypes = Object.freeze({
  BANKSELECT: 0,
  CREDENTIALS: 1,
  PARTIAL: 2,
  OTP: 3,
  ACCOUNTSELECT: 4,
  CONFIRMCANCEL: 5,
  CAPTCHA: 6,
  CARDPIN: 7,
  BANKAUTHTIMER: 8,
  FINALISENEDBANKDIRECT: 9,
  ABSAAUTHSCREEN: 10,
  ABSAACCOUNTSELECT: 11,
})

const instructionTypes = Object.freeze({
  MESSAGE: 0,
  CANCEL: 1,
  RETRY: 2,
  TIMER: 3,
  COMPLETED: 4,
  APPAUTH: 5,
  APPAUTHEXTRA: 6,
  BEHAVIOURNONE: 7,
})

export default Object.freeze({
  mailto: 'support@sidpayment.com',
  cancelTransactionTimeout: 2 * 60 * 1000,
  urlRegexp:
    /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/,
  completeTimer: 3,
  cancelTimer: 5,
  isShowBalance: true,
  maxRetryOnError: 2,
  requestPages: Object.freeze({
    [requestTypes.BANKSELECT]: 'banks',
    [requestTypes.CREDENTIALS]: 'login',
    [requestTypes.PARTIAL]: 'partialPassword',
    [requestTypes.OTP]: 'otp',
    [requestTypes.ACCOUNTSELECT]: 'accounts',
    [requestTypes.CAPTCHA]: 'login',
    [requestTypes.CARDPIN]: 'cardPin',
    [requestTypes.BANKAUTHTIMER]: 'countdownTimer',
    [requestTypes.FINALISENEDBANKDIRECT]: 'nedbankFinalisePayment',
    [requestTypes.ABSAAUTHSCREEN]: 'absaAuthScreen',
    [requestTypes.ABSAACCOUNTSELECT]: 'absaAccounts',
  }),
  instructionPages: Object.freeze({
    [instructionTypes.CANCEL]: 'cancelled',
    [instructionTypes.RETRY]: 'cancelled',
    [instructionTypes.COMPLETED]: 'completed',
    [instructionTypes.APPAUTHEXTRA]: 'qr',
  }),
  logRequests: Object.freeze({
    [requestTypes.CREDENTIALS]: [logMessages.showLogin],
    [requestTypes.PARTIAL]: [logMessages.showPartialPassword],
    [requestTypes.OTP]: [logMessages.showOtp],
    [requestTypes.ACCOUNTSELECT]: [logMessages.showAccounts],
    [requestTypes.CONFIRMCANCEL]: [logMessages.showConfirmCancel],
    [requestTypes.CAPTCHA]: [logMessages.showLoginAndCaptcha],
  }),
  capitecPayInputOptions: Object.freeze([
    Object.freeze({
      identifierKey: capitecPayInputConfig.mobile.key,
      label: capitecPayInputConfig.mobile.label,
      active: true,
      value: '',
      regex: capitecPayInputConfig.mobile.regex,
    }),
    Object.freeze({
      identifierKey: capitecPayInputConfig.account.key,
      label: capitecPayInputConfig.account.label,
      active: false,
      value: '',
      regex: capitecPayInputConfig.account.regex,
    }),
    Object.freeze({
      identifierKey: capitecPayInputConfig.id.key,
      label: capitecPayInputConfig.id.label,
      active: false,
      value: '',
      regex: capitecPayInputConfig.id.regex,
    }),
  ]),
  bankApiActionTypes: Object.freeze({
    CREATE: 'Create',
    STATUS: 'Status',
    InitiateCallback: 'Initiate',
  }),
  banks: Object.freeze([
    Object.freeze({
      acquirerCode: acquirerCodes.Absa,
      label: bankNames.ABSA,
      alt: bankNames.ABSA,
      logo: absa,
      formLogo: absaForm,
      background: '#a90c2b',
      component: AbsaBankForm,
    }),
    Object.freeze({
      acquirerCode: acquirerCodes.CapitecPay,
      label: bankNames.CAPPAY,
      alt: bankNames.CAPPAY,
      logo: capitec,
      formLogo: capitecForm,
      background: '#01466f',
      component: CapitecPayBankForm,
    }),
    Object.freeze({
      acquirerCode: acquirerCodes.NedbankPay,
      label: bankNames.NEDPAY,
      alt: bankNames.NEDPAY,
      logo: nedPay,
      formLogo: nedPay,
      background: '#01466f',
      component: NedbankPayBankForm,
    }),
    Object.freeze({
      acquirerCode: acquirerCodes.AbsaPay,
      label: bankNames.ABSAPAY,
      alt: bankNames.ABSAPAY,
      background: '#a90c2b',
      component: AbsaPayBankForm,
    }),
    Object.freeze({
      acquirerCode: acquirerCodes.Capitec,
      label: bankNames.CAPITEC,
      alt: bankNames.CAPITEC,
      logo: capitec,
      formLogo: capitecForm,
      background: '#01466f',
      component: CapitecBankForm,
    }),
    Object.freeze({
      acquirerCode: acquirerCodes.FNB,
      label: bankNames.FNB,
      alt: bankNames.FNB,
      logo: fnb,
      formLogo: fnbForm,
      background: '#009ea7',
      component: FnbBankForm,
    }),
    Object.freeze({
      acquirerCode: acquirerCodes.Investec,
      label: bankNames.INVESTEC,
      alt: bankNames.INVESTEC,
      logo: investec,
      formLogo: investecForm,
      background: '#000000',
      component: InvestecBankForm,
    }),
    Object.freeze({
      acquirerCode: acquirerCodes.Nedbank,
      label: bankNames.NEDBANK,
      alt: bankNames.NEDBANK,
      logo: nedbank,
      formLogo: nedbankForm,
      background: '#00633a',
      component: NedBankForm,
    }),
    Object.freeze({
      acquirerCode: acquirerCodes.StandardBank,
      label: bankNames.SBSA,
      alt: bankNames.SBSA,
      logo: standardBank,
      formLogo: standardBankForm,
      background: '#01379b',
      component: StandardBankForm,
    }),
    Object.freeze({
      acquirerCode: acquirerCodes.Tyme,
      label: bankNames.TYME,
      alt: bankNames.TYME,
      logo: tymeBank,
      formLogo: tymeBankForm,
      background: '#fec32f',
      component: TymeBankForm,
    }),
    Object.freeze({
      acquirerCode: acquirerCodes.BidvestBank,
      label: bankNames.BIDVEST,
      alt: bankNames.BIDVEST,
      logo: bidvestBank,
      formLogo: bidvestBankForm,
      background: '#00205a',
      component: BidvestBankForm,
    }),
    Object.freeze({
      acquirerCode: acquirerCodes.AfricanBank,
      label: bankNames.AFRICAN,
      alt: bankNames.AFRICAN,
      logo: africanBank,
      formLogo: africanBankForm,
      background: '#89bc47',
      component: AfricanBankForm,
    }),
    Object.freeze({
      acquirerCode: acquirerCodes.SidDemo,
      label: bankNames.SID,
      alt: bankNames.SID,
      logo: mockBank,
      formLogo: mockBank,
      background: '#3299cf',
      component: MockBankForm,
    }),
  ]),
  errors: Object.freeze({
    requestError: 'Some error occurred, please contact support',
    internalError: 'Some error occurred, please contact support',
    cancelTransactionError: 'You cancelled transaction',
  }),
  acquirerCodes,
  bankNames,
  logMessages,
  capitecPayInputConfig,
  absaPayInputConfig,
  requestTypes,
  instructionTypes,
})
